// Shared helpers for the TV surveillance screens: audible alarm + fullscreen.
let _ctx = null;

export function playAlarm(severity = "high") {
  try {
    _ctx = _ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (_ctx.state === "suspended") _ctx.resume();
    const ctx = _ctx;
    const now = ctx.currentTime;
    const beeps = severity === "critical" ? 4 : 2;
    for (let i = 0; i < beeps; i++) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "square";
      osc.frequency.value = severity === "critical" ? 880 : 660;
      const t = now + i * 0.28;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.24);
    }
  } catch (e) {
    /* audio blocked until user interacts — safe to ignore */
  }
}

export function toggleFullscreen(el) {
  const node = el || document.documentElement;
  if (!document.fullscreenElement) {
    (node.requestFullscreen || node.webkitRequestFullscreen)?.call(node);
  } else {
    (document.exitFullscreen || document.webkitExitFullscreen)?.call(document);
  }
}
